import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-lg font-bold text-background-50">
              LitBuy Spreadsheets
            </Link>
            <p className="mt-3 text-xs leading-relaxed text-background-50/50 max-w-xs">
              An independent educational resource providing guides, tutorials, and spreadsheet
              templates for better data organization and tracking.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/what-is-litbuy-spreadsheet" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  What Is a LitBuy Spreadsheet?
                </Link>
              </li>
              <li>
                <Link to="/article/litbuy-spreadsheet-guide" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  How to Create One
                </Link>
              </li>
              <li>
                <Link to="/article/litbuy-spreadsheet-template" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  Best Templates
                </Link>
              </li>
              <li>
                <Link to="/article/litbuy-spreadsheet-vs-manual" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  Spreadsheet vs Manual
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-4">
              Categories
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  Hoodies/Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  Jackets
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  LitBuy Spreadsheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} LitBuy Spreadsheets. An independent educational resource.
              Not affiliated with any third-party brands.
            </p>
            <div className="flex items-center gap-5">
              <Link to="/" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">
                Terms of Use
              </Link>
              <a href="mailto:contact@litbuyspreadsheets.best" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">
                Contact
              </a>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="font-heading text-5xl md:text-7xl font-bold text-background-50/5 select-none tracking-widest">
            LITBUY
          </p>
        </div>
      </div>
    </footer>
  );
}